import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Search16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 1.25C5.82436 1.25 3.25 3.82436 3.25 7C3.25 8.31746 3.69308 9.53143 4.43836 10.501L1.46973 13.4697L2.53039 14.5303L5.49902 11.5617C6.46862 12.3069 7.68257 12.75 9 12.75C12.1756 12.75 14.75 10.1756 14.75 7C14.75 3.82436 12.1756 1.25 9 1.25ZM4.75 7C4.75 4.65279 6.65279 2.75 9 2.75C11.3472 2.75 13.25 4.65279 13.25 7C13.25 9.34721 11.3472 11.25 9 11.25C6.65279 11.25 4.75 9.34721 4.75 7Z'
      fill='currentColor'
    />
  </Svg>
);

Search16.displayName = 'Search16';
export default Search16;
